<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <!-- Кузов прицепа -->
    <path
      d="M3 7h15v8H3V7z"
      :stroke="stroke"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <!-- Сцепка -->
    <path
      d="M18 13h3M21 13v2"
      :stroke="stroke"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <!-- Колеса -->
    <circle cx="8" cy="18" r="2" :stroke="stroke" stroke-width="2" />
    <circle cx="15" cy="18" r="2" :stroke="stroke" stroke-width="2" />
  </svg>
</template>

<script>
export default {
  name: "TrailerIcon",

  props: {
    size: {
      type: [Number, String],
      default: 20,
    },
    stroke: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
